import React from 'react'
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import MessageSidebar from './MessageSidebar'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const SupervisorMessage = () => {
  return (
    <>
      <Header />
      <div className="inner_slider">
        <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/inner_slider.jpg" className="img-fluid inner_slider_img" alt="St. Xaviers Bathinda" />  </LazyLoad>
        <div className="row bread_cumb">
          <h2>Coordinator's Message</h2>
          <div className="theme-heading">
            <span className="colorW marB10"><i className="bi bi-building"></i></span>
          </div>
          <h5><Link to="/">Home <i className="bi bi-arrow-right"></i></Link><span>Message <i className="bi bi-arrow-right"></i> Coordinator's Message</span></h5>
        </div>
      </div>
      <div className="clr"></div>
      <div className="innerpage">
        <div className="row inner_cont">
          <div className="col-lg-9 col-md-8 col-sm-12 col-12 message_inner">
            <article>
              <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Supervisor.jpeg" className="img-fluid" alt="St. Xaviers Bathinda" /></LazyLoad>
              <h3>Coordinator's Message (Senior Wing)</h3>
              <p><strong>Learning Hearts: Daring Minds</strong></p>
              <p>To shape and mould the future of each child is a noble responsibility that we all share—parents, teachers, and the school alike. At St. Xavier’s, we honor this partnership by nurturing every student’s intellectual curiosity and guiding their holistic growth. Our aim is not only to build a strong academic foundation but also to cultivate compassionate, responsible citizens of tomorrow.</p>
              <p>I extend my deepest gratitude to our innovative educators, who continually challenge traditional teaching methods. Through interactive activities, cooperative learning, and hands‑on experiments, they spark creativity and critical thinking in our classrooms, driving a quiet revolution in education.</p>
              <p>My vision for an ideal learning environment is one where every student discovers and hones their unique talents. That’s why we place great emphasis on extra‑curricular opportunities—whether in arts, sports, or community service—so that children can explore their strengths, learn from mistakes and transform challenges into stepping stones for success.</p>
              <p>Our Mascot:– “Learning Hearts, Daring Minds”</p>
              <p>With outstretched wings of compassion, reminds us to lean into one another—offering kindness, support and community—and to nurture daring minds that question boldly and explore bravely. </p>
              <p>In alignment with India’s New Education Policy (NEP) 2020, our mascot embodies the policy’s vision of holistic, experiential and multidisciplinary learning. “Leaning Hearts” reflects NEP’s emphasis on empathy, collaborative learning, and character development, while “Daring Minds” captures its focus on critical thinking, creativity and lifelong curiosity. Together, we soar on twin currents of compassion and innovation, empowering every Xavierite to transform challenges into opportunities and become forward‑thinking leaders of tomorrow.</p>
              <p>Having begun my journey here as an alumna, then teacher and Supervisor of the Senior Wing, I am both humbled and honored now to serve as your School Coordinator. </p>
              <p>Each role has deepened my understanding that every day brings new insights and experiences. I’m proud of our Xavierite legacy, the high standards set by our staff and the distinctive opportunities we offer our students.</p>
              <p>Thank you for entrusting us with your child’s education. Together, let us continue to build a caring, inspiring community where every child can thrive.</p>
              <p>God bless you all..!!!!</p>
              <br />
              <h5><strong>Ms. Nupur </strong></h5>
              <h4>Coordinator (Senior Wing)</h4>
            </article>
            <div className="clr"></div>
          </div>
          <MessageSidebar />
          <div className="clr"></div>
        </div>

        <div className="clr"></div>
      </div>
      <div className="clr"></div>
      <Footer />
    </>
  )
}

export default SupervisorMessage
